export default __webpack_public_path__ + "static/media/GLEnglish.3db6021e.jpg";